export default {"src":"/_next/static/media/reddit.f6dd03d4.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};